module.exports = __webpack_public_path__ + "static/body_7-5a87425c574284a0410071f69c5aa9d4.png";